// AI Interface - React App (Modular Structure)
import React from 'react';
import { createRoot } from 'react-dom/client';
import AppRouter from './router/AppRouter.js';

// Build timestamp for cache busting verification
const BUILD_TIMESTAMP = new Date().toISOString();
console.log(`%c🚀 AI Hub Client Bundle Loaded`, 'color: #7D97EB; font-size: 14px; font-weight: bold;');
console.log(`%c📦 Build Time: ${BUILD_TIMESTAMP}`, 'color: #7D97EB; font-size: 12px;');

// Only render the app if we're in a browser environment (not in tests)
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  // Render the app using React 18 createRoot API
  const container = document.getElementById('ai-interface-root');
  if (container) {
    const root = createRoot(container);
    root.render(<AppRouter />);
  } else {
    console.error('Root element #ai-interface-root not found');
  }
}
